import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckDates } from '@api/hitoryCheck';

import { extractQueryParams } from '@utils/common';
import { getDateWithoutOffset } from '@utils/kpi-utils/date';

import { ICMMavenirVendor } from '@interfaces/cmModule/cmModule';
import { TCMDefaultDTO } from '@interfaces/cmModule/dto/cmModuleDTO';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_DATES } from '@constants/queryKeys';

type TUseQueryHistoryCheckDates = TCMDefaultDTO & ICMMavenirVendor;

interface IUseQueryHistoryCheckDatesReturnValue {
	dates: Date[];
	isFetchingDates: boolean;
	isLoadingDates: boolean;
}

export const useQueryHistoryCheckDates = (
	params: TUseQueryHistoryCheckDates,
): IUseQueryHistoryCheckDatesReturnValue => {
	const {
		vendor,
		technology,
		nodeType,
		siteIds,
		isMavenirVendor,
	} = params;

	const {
		data: dates,
		isFetching: isFetchingDates,
		isLoading: isLoadingDates,
	} = useQuery<number[], Date[]>({
		queryKey: [HISTORY_CHECK_DATES, params],
		queryFn: extractQueryParams(getHistoryCheckDates),
		select: (dates) => dates.map((date) => getDateWithoutOffset(date)),
		enabled: [
			!isMavenirVendor,
			!!technology,
			!!vendor,
			!!nodeType,
			!!siteIds.length,
		],
		...refetchOptions,
	});

	return {
		dates: dates || [],
		isFetchingDates: isFetchingDates,
		isLoadingDates: (isLoadingDates && !!dates) || isFetchingDates,
	};
};
